<style lang="stylus">
    .AddSymbolFromWeb-mask
        modal-mask()
        .AddSymbolFromWeb-modal
            width 410px
            height 180px
            .AddSymbolFromWeb-container
                padding 30px 20px
                .AddSymbolFromWeb-line
                    display flex
                    justify-content space-around
                    >p
                        line-height 24px
                        width 85px
</style>

<template>
    <div class="AddSymbolFromWeb-mask">
        <Dialog class="AddSymbolFromWeb-modal" :title="$t('title')" :isShow="true" @close="closeModal">
            <div class="AddSymbolFromWeb-container">
                <div class="AddSymbolFromWeb-line">
                    <p>{{ $t("name") }}:</p>
                    <Input v-model="symbolName" size="small" style="width: 260px" />
                </div>
            </div>

            <div class="dialog-btnbox-normal" :style="{ direction: !internal ? 'ltr' : 'rtl' }">
                <div class="dialog-btn-ok" @click="confirm()">{{ $t("confirm") }}</div>
                <div class="" @click="closeModal()">{{ $t("cancel") }}</div>
            </div>
        </Dialog>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";
    import appConfig from "@/public/globalConfig";
    import Dialog from "../Dialog.vue";

    @Component({
        components: {
            Dialog,
        },
    })
    export default class AddSymbolFromWeb extends Vue {
        symbolName: string = "";
        userWorkerURL: string = appConfig.userWorkerURL;
        worker: any;
        reflashLibrary() {
            // 通知library刷新列表
            let dbName = this.dbAndTable[0];
            let tableName = this.dbAndTable[1];
            let tableID = this.dbAndTable[2];
            let ts: any = this;
            ts.$bus.$emit("setLibrary", {
                type: "updateLibrary",
                groupName: dbName,
                tableID: tableID,
            });
        }
        addSymbolToDB() {
            let dbName = this.dbAndTable[0];
            let tableName = this.dbAndTable[1];
            let tableID = this.dbAndTable[2];
            let dbObj = {
                name: this.symbolName,
            };
            let a = window["_view"].saveAsSymbol("");
            let userInfo = this.$store.state.user.userInfo;
            a.then((symbolData) => {
                dbObj["data"] = symbolData[1];
                dbObj["parent"] = tableName;
                dbObj["blob"] = symbolData[0];
                let updateData = {
                    DBName: this.dbAndTable[0],
                    tableName: this.dbAndTable[1],
                    tableID: this.dbAndTable[2],
                    nowItem: this.libClickObj.nowItem,
                    updateType: "addSymbol",
                    dbObj: dbObj,
                    versionDB: `myDBVersion_${userInfo.user_id}`,
                };

                this.worker = new Worker(this.userWorkerURL);
                this.worker.postMessage({
                    type: "update",
                    urls: this.urls,
                    data: updateData,
                });
                let ossList = this.$store.state.library.ossList;
                this.worker.onmessage = (e) => {
                    let message = e.data;
                    if (message.type === "updateOK") {
                        this.reflashLibrary();
                        let ts: any = this;
                        ts.$bus.$asyncEmit("uploadToCloud", { message }).then((e: any) => {
                            let version = e.data.version;
                            this.worker.postMessage({
                                type: "setVersion",
                                urls: this.urls,
                                data: {
                                    versionDB: `myDBVersion_${userInfo.user_id}`,
                                    tableID: this.dbAndTable[2],
                                    version,
                                    params: {
                                        updateModified: true,
                                    },
                                },
                            });
                        });
                    } else if (message.type === "setVersionOK") {
                        this.worker.terminate();
                    }
                };
            });
        }
        confirm() {
            this.addSymbolToDB();
            this.closeModal();
        }
        closeModal() {
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: false,
            });
        }
        mounted() {}

        created() {}
        get dbAndTable() {
            return this.$store.state.ui.selectLibrary;
        }
        get libClickObj() {
            return this.$store.state.ui.libClickObj;
        }
    }
</script>
<i18n>
{
  "zh": {
    "title": "从页面导入库",
    "name": "符号名称",
    "confirm": "确定",
    "cancel": "取消"
  },
  "en": {
    "title": "Import Library from Page",
    "name": "Symbol Name",
    "confirm": "OK",
    "cancel": "Cancel"
  },
  "fr": {
    "title": "Importer la bibliothèque de la page",
    "name": "Nom symbolique",
    "confirm": "Confirmer",
    "cancel": "Annuler"
  },
  "de": {
    "title": "Bibliothek von Seite importieren ",
    "name": "Symbolname",
    "confirm": "Sichern",
    "cancel": "Abbrechen"
  },
  "jp": {
    "title": "ページからライブラリをインポート",
    "name": "図形名",
    "confirm": "OK",
    "cancel": "キャンセル"
  },
  "es": {
    "title": "Importar la biblioteca de la página",
    "name": "Nombre del símbolo",
    "confirm": "Aceptar",
    "cancel": "Cancelar"
  },
  "pt": {
    "title": "Importar Biblioteca de Página",
    "name": "Nome de Símbolo",
    "confirm": "OK",
    "cancel": "Cancelar"
  },
  "it": {
    "title": "Importa Libreria da Pagina",
    "name": "Nome Simbolo",
    "confirm": "OK",
    "cancel": "Annulla"
  },
  "tw": {
    "title": "從頁面導入庫",
    "name": "符號名稱",
    "confirm": "確定",
    "cancel": "取消"
  },
  "kr": {
    "title": "페이지에서 라이브러리 가져오기",
    "name": "심볼 이를 ",
    "confirm": "확인 ",
    "cancel": "취소 "
  }
}
</i18n>
